import { ApplicationMetricsContextStates, } from './application-metrics-context-states';
const contextState = {
    currentState: ApplicationMetricsContextStates.DEFAULT_PAGE,
    dialogStates: [],
};
function setContextState(state) {
    contextState.currentState = state;
}
function pushDialogContextState(state) {
    contextState.dialogStates.push(state);
}
function popDialogContextState() {
    contextState.dialogStates.pop();
}
function getContextState() {
    const totalDialogStates = contextState.dialogStates.length;
    return ((totalDialogStates > 0
        ? contextState.dialogStates[totalDialogStates - 1]
        : contextState.currentState) ||
        ApplicationMetricsContextStates.DEFAULT_PAGE);
}
function getNonDialogState() {
    return (contextState.currentState ||
        ApplicationMetricsContextStates.DEFAULT_PAGE);
}
export { ApplicationMetricsContextStates, setContextState, pushDialogContextState, popDialogContextState, getContextState, getNonDialogState, };
//# sourceMappingURL=application-metrics-context-service.js.map